import React from "react";
import { IEmbedOptions } from "../types/xdm";
import { IMessenger } from "@ms/utilities-cross-window";

export interface IEmbedContext extends IEmbedOptions {
  hostClient?: IMessenger & { dispose: () => void };
}

export const EmbedContext = React.createContext<IEmbedContext>({});
